import { render, staticRenderFns } from "./kycCreate.vue?vue&type=template&id=1f9676b4&"
import script from "./kycCreate.vue?vue&type=script&lang=js&"
export * from "./kycCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports